import React from 'react';
import { Switch, Route } from 'react-router';
import { Home } from './features/home/Home';
import { HowToUse } from './features/how-to-use/HowToUse';
import { Faq } from './features/faq/Faq';
import { RegisterSupplier } from './features/register-supplier/RegisterSupplier';
import { Ebook } from './features/ebook/Ebook';
import { TermsAndCondition } from './components/terms-and-condition/TermsAndCondition';
import { PrivacyPolicy } from './components/privacy-policy/PrivacyPolicy';


const routes = (
    <Switch>
        <Route path="/cara-pakai" component={HowToUse} onUpdate={() => window.scrollTo(0, 0)} />
        <Route path="/faq" component={Faq} />
        <Route path="/daftar-supplier" component={RegisterSupplier} />
        <Route path="/ebook-vip" component={Ebook} />
        <Route path="/syarat-dan-ketentuan" component={TermsAndCondition} />
        <Route path="/kebijakan-privasi" component={PrivacyPolicy} />
        <Route path="/" component={Home} />
    </Switch>
);

export const AppRouter = () => {
    return routes;
}

export default routes;